<div class="atn-mosaic-chart-footer">
  @for (legendItem of legendItemsSg(); track $index) {
    <div
      class="atn-mosaic-chart-footer__legend-item"
      [style.--background-color]="legendItem?.color"
    >
      {{ legendItem?.name }}
    </div>
  }
</div>
